import React from 'react';
import bg from '../img/bg.svg';
import { motion } from 'framer-motion';

const buttonVariants = {
  hover: {
    scale: 1.1,
    transition: { yoyo: Infinity, duration: 0.3 },
  },
};
const resumeVariants = {
  hover: {
    scale: 1.1,
    transition: { yoyo: Infinity, duration: 0.5, originX: 0 },
  },
};

const sectionVariants = {
  hidden: {
    opacity: 0,
    x: '-100vw',
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      when: 'beforeChildren',
      ease: 'easeInOut',
      duration: 1,
    },
  },
};

const welcomeTitleVariant = {
  hidden: {
    opacity: 0,
  },
  visible: {
    opacity: 1,
    transition: {
      duration: 1,
      ease: 'easeIn',
      when: 'beforeChildren',
    },
  },
};

const heroImageVariants = {
  hidden: {
    opacity: 0,
    x: '100vw',
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      ease: 'easeInOut',
      duration: 1,
      delay: 0.5,
    },
  },
};

const Welcome = () => {
  return (
    <section
      id="welcome"
      className="container mx-auto text-4xl flex items-center sm:flex sm:justify-between min-h-screen"
    >
      <motion.div
        variants={sectionVariants}
        initial="hidden"
        animate="visible"
        className="flex flex-col justify-center items-start w-full px-8 sm:w-3/5 sm:flex sm:flex-col sm:justify-center sm:items-start"
      >
        <motion.p
          variants={welcomeTitleVariant}
          className="text-2xl capitalize text-indigo-700 font-curl"
        >
          Hi there{' '}
          <span className="text-xl md:text-3xl" role="img" aria-label="sheep">
            👋
          </span>
          , <br />{' '}
          <span className="text-2xl md:text-4xl font-header">
            My Name is <br className="sm:hidden" /> Godisgreat Agu
          </span>
        </motion.p>
        <p className="text-sm sm:text-xl font-mono tracking-widest mt-4">
          I'm a Software Developer based in Abuja, Nigeria.
        </p>
        <div className="flex flex-col">
          <div className={`mt-6 flex space-x-2`}>
            <motion.a
              href="https://github.com/Chijioke91"
              target="_blank"
              rel="noopener noreferrer"
              variants={buttonVariants}
              whileHover="hover"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                width="1em"
                height="1em"
                viewBox="0 0 24 24"
                transform="rotate(360)"
                className="fill-current"
              >
                <title>Github</title>
                <path d="M12 2A10 10 0 002 12c0 4.42 2.87 8.17 6.84 9.5.5.08.66-.23.66-.5v-1.69c-2.77.6-3.36-1.34-3.36-1.34-.46-1.16-1.11-1.47-1.11-1.47-.91-.62.07-.6.07-.6 1 .07 1.53 1.03 1.53 1.03.87 1.52 2.34 1.07 2.91.83.09-.65.35-1.09.63-1.34-2.22-.25-4.55-1.11-4.55-4.92 0-1.11.38-2 1.03-2.71-.1-.25-.45-1.29.1-2.64 0 0 .84-.27 2.75 1.02.79-.22 1.65-.33 2.5-.33.85 0 1.71.11 2.5.33 1.91-1.29 2.75-1.02 2.75-1.02.55 1.35.2 2.39.1 2.64.65.71 1.03 1.6 1.03 2.71 0 3.82-2.34 4.66-4.57 4.91.36.31.69.92.69 1.85V21c0 .27.16.59.67.5C19.14 20.16 22 16.42 22 12A10 10 0 0012 2z" />
              </svg>
            </motion.a>
            <motion.a
              href="mailto:agugodisy@gmail.com"
              variants={buttonVariants}
              whileHover="hover"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                width="1em"
                height="1em"
                viewBox="0 0 24 24"
                transform="rotate(360)"
                className="fill-current"
              >
                <title>Email</title>
                <path d="M20 8l-8 5-8-5V6l8 5 8-5m0-2H4c-1.11 0-2 .89-2 2v12a2 2 0 002 2h16a2 2 0 002-2V6a2 2 0 00-2-2z" />
              </svg>
            </motion.a>
            <motion.a
              href="https://twitter.com/dev_cjay"
              target="_blank"
              rel="noopener noreferrer"
              variants={buttonVariants}
              whileHover="hover"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                width="1em"
                height="1em"
                viewBox="0 0 24 24"
                transform="rotate(360)"
                className="fill-current"
              >
                <title>Twitter</title>
                <path d="M22.46 6c-.77.35-1.6.58-2.46.69.88-.53 1.56-1.37 1.88-2.38-.83.5-1.75.85-2.72 1.05C18.37 4.5 17.26 4 16 4c-2.35 0-4.27 1.92-4.27 4.29 0 .34.04.67.11.98C8.28 9.09 5.11 7.38 3 4.79c-.37.63-.58 1.37-.58 2.15 0 1.49.75 2.81 1.91 3.56-.71 0-1.37-.2-1.95-.5v.03c0 2.08 1.48 3.82 3.44 4.21a4.22 4.22 0 01-1.93.07 4.28 4.28 0 004 2.98 8.521 8.521 0 01-5.33 1.84c-.34 0-.68-.02-1.02-.06C3.44 20.29 5.7 21 8.12 21 16 21 20.33 14.46 20.33 8.79c0-.19 0-.37-.01-.56.84-.6 1.56-1.36 2.14-2.23z" />
              </svg>
            </motion.a>
            <motion.a
              href="https://www.linkedin.com/in/godis-agu-105619156/"
              target="_blank"
              rel="noopener noreferrer"
              variants={buttonVariants}
              whileHover="hover"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                width="1em"
                height="1em"
                viewBox="0 0 24 24"
                transform="rotate(360)"
                className="fill-current"
              >
                <title>Linkedin</title>
                <path d="M19 3a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h14m-.5 15.5v-5.3a3.26 3.26 0 00-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 011.4 1.4v4.93h2.79M6.88 8.56a1.68 1.68 0 001.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 00-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77z" />
              </svg>
            </motion.a>
            <motion.a
              href="https://www.instagram.com/godisagu/"
              target="_blank"
              rel="noopener noreferrer"
              variants={buttonVariants}
              whileHover="hover"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                width="1em"
                height="1em"
                viewBox="0 0 24 24"
                transform="rotate(360)"
                className="fill-current"
              >
                <title>Instagram</title>
                <path d="M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 01-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 017.8 2m-.2 2A3.6 3.6 0 004 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8a3.6 3.6 0 003.6-3.6V7.6C20 5.61 18.39 4 16.4 4H7.6m9.65 1.5a1.25 1.25 0 011.25 1.25A1.25 1.25 0 0117.25 8 1.25 1.25 0 0116 6.75a1.25 1.25 0 011.25-1.25M12 7a5 5 0 015 5 5 5 0 01-5 5 5 5 0 01-5-5 5 5 0 015-5m0 2a3 3 0 00-3 3 3 3 0 003 3 3 3 0 003-3 3 3 0 00-3-3z" />
              </svg>
            </motion.a>
          </div>
          <motion.div variants={resumeVariants} whileHover="hover">
            <a
              href="resume.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block cursor-pointer text-xl mt-4 border-b-4 border-indigo-700 font-mono tracking-widest"
            >
              Resume
            </a>
          </motion.div>
        </div>
      </motion.div>

      <motion.div
        variants={heroImageVariants}
        initial="hidden"
        animate="visible"
        className="ml-10 w-2/5 sm:flex sm:flex-col sm:justify-center"
      >
        <img
          src={bg}
          alt="Developer illustration"
          className="hidden sm:block"
        />
      </motion.div>
    </section>
  );
};

export default Welcome;
